import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../store/customRequest/actions";
import { LEGACY_CONVERSION_BATCH_PATH, LEGACY_CONVERSION_DEFAULT_OPTIONS, LEGACY_CONVERSION_PATH, } from "./constants/legacyConversion.constants";
import { toLegacyConversionOutcome } from "./legacyConversion.rules";
export var useLegacyConversion = function (requestKey) {
    var dispatch = useDispatch();
    var _a = useState("single"), mode = _a[0], setMode = _a[1];
    var data = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[requestKey]) !== null && _c !== void 0 ? _c : null; });
    var loading = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[requestKey]) !== null && _c !== void 0 ? _c : false; });
    var error = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[requestKey]) !== null && _c !== void 0 ? _c : null; });
    var clear = function () { return dispatch(clearCustomRequest(requestKey)); };
    var convertOne = function (code) {
        clear();
        setMode("single");
        dispatch(customRequestApis({
            requestKey: requestKey,
            method: "POST",
            path: LEGACY_CONVERSION_PATH,
            body: {
                code: code,
                options: LEGACY_CONVERSION_DEFAULT_OPTIONS,
            },
        }));
    };
    var convertMany = function (codes) {
        clear();
        setMode("batch");
        dispatch(customRequestApis({
            requestKey: requestKey,
            method: "POST",
            path: LEGACY_CONVERSION_BATCH_PATH,
            body: {
                codes: codes,
                options: LEGACY_CONVERSION_DEFAULT_OPTIONS,
            },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(requestKey));
        };
    }, []);
    var outcome = useMemo(function () { return toLegacyConversionOutcome(data, error, mode); }, [data, error, mode]);
    return { convertOne: convertOne, convertMany: convertMany, outcome: outcome, loading: loading, clear: clear };
};
